import { api } from "@api/api";
import { PayReferralInput, PayReferralResponse } from "./types";

export async function payReferralService({
  id,
  custom_value_paid,
}: PayReferralInput): Promise<PayReferralResponse> {
  const body: Record<string, unknown> = { referral: Number(id) };
  if (custom_value_paid != null) {
    body.custom_value_paid = custom_value_paid;
  }

  const { data } = await api.post<PayReferralResponse>("v2/referral/pay/", body);
  return data;
}
